import dateFns from 'date-fns';
import store from '../../store';

const priceDigitSplitRegexp = /\B(?=(\d{3})+(?!\d))/g;

function presentPrice(price) {
  return price.toString().replace(priceDigitSplitRegexp, ',') + '원';
}

export default [
  {
    bindAttributes: {
      prop: 'payer',
      label: '이름',
      width: 110,
      fixed: 'left',
      sortable: true
    }
  },
  {
    bindAttributes: {
      prop: 'classification',
      label: '구분',
      width: 70,
      columnKey: 'classification',
      filters: [
        {
          text: '신규',
          value: '1'
        },
        {
          text: '재등록',
          value: '2'
        }
      ]
    },
    isHtmlTemplate: true,
    template: scope => {
      return `<span class="table-badge ${
        scope.row.classification === 2 ? 'reenlist' : ''
      }">${scope.row.classification === 2 ? '재등록' : '신규'}</span>`;
    }
  },
  {
    bindAttributes: {
      prop: 'membership',
      label: '결제 회원권',
      sortable: true
    },
    template: scope => {
      const membership =
        store.getters.getParentMembershipsInKeys[scope.row.membership];

      if (membership) {
        return membership.name;
      }
    }
  },
  {
    bindAttributes: {
      prop: 'total',
      label: '결제 금액',
      width: 100,
      sortable: true
    },
    template: scope => {
      return presentPrice(scope.row.total);
    }
  },
  {
    bindAttributes: {
      prop: 'card',
      label: '카드',
      width: 100,
      sortable: true
    },
    template: scope => {
      return presentPrice(scope.row.card);
    }
  },
  {
    bindAttributes: {
      prop: 'cash',
      label: '현금',
      width: 100,
      sortable: true
    },
    template: scope => {
      return presentPrice(scope.row.cash);
    }
  },
  {
    bindAttributes: {
      prop: 'remainder',
      label: '미수금',
      width: 100,
      sortable: true
    },
    template: scope => {
      return presentPrice(scope.row.remainder);
    }
  },
  {
    bindAttributes: {
      prop: 'paid_at',
      label: '결제일',
      width: 100,
      sortable: true
    },
    template: scope => {
      return dateFns.format(scope.row.paid_at, 'YY.MM.DD');
    }
  }
];
